// One namespace per area of the app, each in locales/<language>/<namespace>.json, so the
// areas can be translated independently. "translation" (locales/<language>.json) is the
// default: Settings, navigation, and the strings shared everywhere.
import en from "./locales/en.json";
import es from "./locales/es.json";
import sw from "./locales/sw.json";
import en_home from "./locales/en/home.json";
import es_home from "./locales/es/home.json";
import sw_home from "./locales/sw/home.json";
import en_masterchart from "./locales/en/masterchart.json";
import es_masterchart from "./locales/es/masterchart.json";
import sw_masterchart from "./locales/sw/masterchart.json";
import en_medications from "./locales/en/medications.json";
import es_medications from "./locales/es/medications.json";
import sw_medications from "./locales/sw/medications.json";
import en_assistant from "./locales/en/assistant.json";
import es_assistant from "./locales/es/assistant.json";
import sw_assistant from "./locales/sw/assistant.json";
import en_careStart from "./locales/en/careStart.json";
import es_careStart from "./locales/es/careStart.json";
import sw_careStart from "./locales/sw/careStart.json";
import en_visitStart from "./locales/en/visitStart.json";
import es_visitStart from "./locales/es/visitStart.json";
import sw_visitStart from "./locales/sw/visitStart.json";
import en_account from "./locales/en/account.json";
import es_account from "./locales/es/account.json";
import sw_account from "./locales/sw/account.json";

export const NAMESPACES = ["translation", "home", "masterchart", "medications", "assistant", "careStart", "visitStart", "account"];

const enResources = {
  translation: en,
  home: en_home,
  masterchart: en_masterchart,
  medications: en_medications,
  assistant: en_assistant,
  careStart: en_careStart,
  visitStart: en_visitStart,
  account: en_account,
};
const esResources = {
  translation: es,
  home: es_home,
  masterchart: es_masterchart,
  medications: es_medications,
  assistant: es_assistant,
  careStart: es_careStart,
  visitStart: es_visitStart,
  account: es_account,
};
const swResources = {
  translation: sw,
  home: sw_home,
  masterchart: sw_masterchart,
  medications: sw_medications,
  assistant: sw_assistant,
  careStart: sw_careStart,
  visitStart: sw_visitStart,
  account: sw_account,
};

export const RESOURCES = { en: enResources, es: esResources, sw: swResources };
